import { Outlet, useParams } from 'react-router-dom'

import { AppStorePoliciesDocument } from 'generated/resources/graphql'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import SectionContainer from 'modules/core/components/SectionContainer'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'
import hasFeature from 'modules/core/lib/hasFeature'

import { APPS } from 'modules/billing/lib/types'
import { hasRegularAccessOrNotEmployee } from 'modules/employees/lib/utils'

import CollectionsBootstrap from '../lib/CollectionsBootstrap'

const Container = () => {
  const { id } = useParams<{ id: string }>()
  const schemaId = Number(id)
  const { employee } = useCurrentSession()
  const { data, loading } = useQuery(AppStorePoliciesDocument)

  if (loading) return null

  const canSeePerformance = data?.apiCore._policies.accessReviewsCreateTemplates.can
  const canSeeSurveys = data?.apiCore._policies.accessSurveysCreateTemplates.can
  const canSeeShifManagement = data?.shiftManagement._policies.accessManageTemplates.can
  const canSeeCompetencies = data?.competencies._policies.competenciesManage.can
  const canSeeAppStore = data?.integrationsBase._policies.seeAppStore.can

  const isAuthorized = () => {
    switch (id) {
      case APPS.performance_v2:
        return canSeePerformance
      case APPS.surveys:
        return canSeeSurveys
      case APPS.shift_management:
        return canSeeShifManagement
      case APPS.competencies:
        return canSeeCompetencies
      case APPS.join:
        return hasFeature('ats_promote_join')
      default:
        return canSeeAppStore
    }
  }

  return (
    <AuthorizeUser
      authorizeFn={() => hasRegularAccessOrNotEmployee(employee) && (isAuthorized() ?? false)}
    >
      <Outlet context={{ schemaId }} />
    </AuthorizeUser>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <SectionContainer>
        <Container />
      </SectionContainer>
    </CollectionsBootstrap>
  )
}

export default RootPage
